import { render, staticRenderFns } from "./AddLoanPayment.vue?vue&type=template&id=bb5b205a&scoped=true&"
import script from "./AddLoanPayment.vue?vue&type=script&lang=js&"
export * from "./AddLoanPayment.vue?vue&type=script&lang=js&"
import style0 from "./AddLoanPayment.vue?vue&type=style&index=0&id=bb5b205a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5b205a",
  null
  
)

export default component.exports